import React from "react";
import {
  formatRupiah,
  getDiscount,
  getFinalPrice,
  getProductImage,
  getSoldPercent,
} from "../utils/ecommerce";

const ProductCard = ({ barang, compact = false, onOpen }) => {
  const discount = getDiscount(barang);
  const soldPercent = getSoldPercent(barang);
  const stok = Number(barang?.stok || 0);
  const hasWholesale = Number(barang?.minimalQtyGrosir || 0) > 0 && Number(barang?.hargaGrosir || 0) > 0;

  return (
    <article
      className={compact ? "product-card compact" : "product-card"}
      onClick={() => onOpen(barang)}
    >
      <div className="product-image-wrap">
        {barang.isFlashsale && (
          <div className="mall-badge">
            Resmi <span>AJS</span>
          </div>
        )}
        {stok <= 0 && <div className="stock-ribbon">Stok Habis</div>}
        {discount > 0 && <div className="discount-corner">-{discount}%</div>}
        <img src={getProductImage(barang)} alt={barang.nama} />
      </div>
      <div className="product-body">
        <h3>{barang.nama}</h3>
        <div className="price">{formatRupiah(getFinalPrice(barang))}</div>
        {discount > 0 && (
          <div className="old-price">{formatRupiah(barang.hargaJual)}</div>
        )}
        {hasWholesale && (
          <div className="wholesale-note">
            Grosir {barang.minimalQtyGrosir}+ pcs {formatRupiah(barang.hargaGrosir)}
          </div>
        )}
        {compact ? (
          <div className="sold-pill">
            <span style={{ width: `${soldPercent}%` }} />
            <b>TERJUAL {Math.round(soldPercent)}%</b>
          </div>
        ) : (
          <div className="card-footer">
            <span>{barang.merk?.nama || "AJS"}</span>
            <small>{barang.kuantitasTerjual || 0} terjual</small>
          </div>
        )}
      </div>
    </article>
  );
};

export default ProductCard;
